import { shallowMount } from "@vue/test-utils";
import StepLoader from "@/components/core/custom/StepLoader";

describe("StepLoader component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(StepLoader, {
      propsData: {
        percentage: 99
      },
      slots: {
        default: "<div></div>"
      }
    });
  });

  it("Renders del component StepLoader", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
